<script>
  import { onMount, afterUpdate } from 'svelte'
  import { draw, fade } from 'svelte/transition'
  import Header from '../header.svelte'
  import Guide01 from '../guides01.svelte'
  import Guide02 from '../guides02.svelte'
  import Guide03 from '../guides03.svelte'
  import Guide04 from '../guides04.svelte'
  import Checkbox from '../checkbox.svelte'
  export let content

  const alignmentGuides = [Guide02, Guide03, Guide04]

  let checked = true
  function toggleArteria() {
    checked = !checked
  }
  let guides = true
  function toggleGuides() {
    guides = !guides
  }

  onMount(() => {
    gsap.from('.geometrica', {
      opacity: 0,
      y: -40,
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.comparison',
        start: 'top bottom',
        toggleActions: 'play none none reverse',
      },
    })
  })
</script>

<div class="cols4-wrapper">
  <div class="text">
    <p>Your headlines will be perfectly aligned.</p>
    <div class="checkbox2">
      <Checkbox name="Construction" on:toggle={toggleGuides} checked={guides} />
    </div>
  </div>
  <div class="alignments">
    {#each content.alignments as alignment, i}
      {#if guides}
        <div class="img-{i + 1} overlay" transition:fade>
          <svelte:component this={alignmentGuides[i]} />
        </div>
      {/if}
      <div class="img-{i + 1}"><img src={alignment.image} alt="" /></div>
    {/each}
  </div>
</div>

<Header title="Human Drawings" />
<div class="cols4-wrapper" id="drawing">
  <div class="text">
    <p>
      Conceptually rational, it’s a fluid design. Compare Arteria with a strict
      “geometric contruction” in grey.
    </p>
  </div>
  <div class="comparison">
    <img
      class="geometrica"
      src={content.comparison.image}
      alt="Geometric outlines"
      style="width:10%;" />
    <img
      class="geometrica"
      src={content.comparison.image_hover}
      alt="Geometric outlines"
      style="width:20%;" />
    <img
      class="geometrica"
      src={content.comparison.image}
      alt="Geometric outlines"
      style="width:50%;" />
    <img
      class="geometrica"
      src={content.comparison.image_hover}
      alt="Geometric outlines"
      style="width:80%;" />
    <img
      class="geometrica"
      src={content.comparison.image}
      alt="Geometric outlines"
      style="width:80%;" />
  </div>
  {#if guides}
    <div class="guides overlay" transition:fade>
      <Guide01 />
    </div>
  {/if}
  <div class="drawing">
    <img
      src={checked ? content.drawing.image : content.drawing.image_hover}
      alt="Geometric outlines" />
  </div>
  <div class="checkbox">
    <Checkbox
      name="Human drawings better for my eyes"
      on:toggle={toggleArteria} />
    <div class="construction" transition:fade>
      <Checkbox name="Construction" on:toggle={toggleGuides} checked={guides} />
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../responsive.scss';

  .checkbox2 {
    z-index: 2;
  }
  .overlay {
    z-index: 2;
  }
  .guides {
    grid-column: 1 / span 2;
    grid-row: 2;

    @include for-tablet-p {
      grid-row: 4;
    }

    @include for-phone {
      grid-column: 1 / span 3;
    }
  }
  .drawing {
    grid-column: 1 / span 2;
    grid-row: 2;
    margin-bottom: 40px;

    @include for-tablet-p {
      grid-row: 4;
      margin-bottom: 0;
    }

    @include for-phone {
      grid-column: 1 / span 3;
    }
  }
  .comparison {
    grid-column: 1 / span 2;
    grid-row: 1;
    img {
      display: block;
      margin-bottom: 10px;
    }

    @include for-tablet-p {
      grid-row: 2;
    }

    @include for-phone {
      grid-column: 1 / span 3;
    }
  }
  .text {
    grid-column: 3;
    grid-row: 1;
    font-size: 4rem;
    font-family: 'Arteria-Regular';
    color: var(--dark);
    p {
      margin-bottom: 40px;
    }

    @include for-tablet {
      font-size: 3rem;
    }

    @include for-tablet-p {
      grid-column: 1 / span 2;
      margin-bottom: 20px;
      p {
        margin-bottom: 10px;
      }
    }

    @include for-phone {
      grid-column: 1 / span 3;
      font-size: 2.5rem;
      p {
        margin-bottom: 0;
      }
    }
  }
  .checkbox {
    justify-self: end;
    margin-top: 14px;

    @include for-tablet-p {
      justify-self: start;
      grid-column: 1 / span 2;
      grid-row: 3;
      margin-bottom: 20px;
      margin-top: 30px;
    }

    @include for-phone {
      grid-column: 1 / span 3;
    }
  }
  .alignments {
    grid-column: 1 / span 2;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 100px;

    @include for-phone {
      grid-column: 1 / span 3;
    }
  }
  .img-1 {
    grid-column: 1;
    grid-row: 1;
  }
  .img-2 {
    grid-column: 2;
    margin-top: 2px;
    margin-left: -1px;
    grid-row: 1;

    @include for-tablet {
      margin-top: 1px;
    }
  }
  .img-3 {
    margin-top: 40px;
    grid-column: 1 / span 2;
    grid-row: 2;
  }
</style>
